import React, { useState } from "react"
import Carousel from "react-bootstrap/Carousel"
import LazyLoad from "react-lazyload"
import { Row, Col } from "reactstrap"

import ReadCase from "../../Buttons/learnMoreCardButton"

const CarouselSubPages = props => {
  const [index, setIndex] = useState(0)
  const [direction, setDirection] = useState(null)

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex)
    setDirection(e.direction)
  }

  return (
    <div className="carousel-subpages">
      <LazyLoad offset={0}>
        <Carousel
          activeIndex={index}
          direction={direction}
          onSelect={handleSelect}
          controls={false}
          interval={8000}
        >
          {props.data.map(data => (
            <Carousel.Item>
              {!props.video ? (
                <Row>
                  {data.description ? (
                    <Col md="6" className="text-wrapper">
                      <div className="heading large-font">{data.title}</div>
                      <div className="description medium-font">
                        {data.description}
                      </div>
                      {data.linkTitle ? (
                        <ReadCase
                          linkTitle={data.linkTitle}
                          learnMore={data.link}
                        />
                      ) : (
                        ""
                      )}
                    </Col>
                  ) : (
                    ""
                  )}
                  {data.clienttitle ? (
                    <Col md="6" className="text-wrapper">
                      <div style={{ flexDirection: "row", display: "flex" }}>
                        <img
                          src={data.clientimg}
                          className="clientImage"
                          alt="Meetrix.IO Expert Jitsi Meet Development service can take your Jitsi Meet infrastructure to the next level"
                        />
                        <div className="heading2 ">
                          <i>{data.clienttitle}</i>
                        </div>
                      </div>
                      <div className="description2">
                        {data.clientdescription}
                      </div>
                      {data.linkTitle ? (
                        <ReadCase
                          linkTitle={data.linkTitle}
                          learnMore={data.clientlink}
                        />
                      ) : (
                        ""
                      )}
                    </Col>
                  ) : (
                    ""
                  )}
                  <Col md="6" className="image-wrapper">
                    <img
                      src={data.img}
                      alt="Meetrix.IO is the most experienced Jitsi Meet service provider"
                    />
                  </Col>
                </Row>
              ) : (
                <div className="video-wrapper">
                  <div className="each-video">video</div>
                  <div className="each-video">video</div>
                  <div className="each-video">video</div>
                </div>
              )}
            </Carousel.Item>
          ))}
        </Carousel>
      </LazyLoad>
    </div>
  )
}

export default CarouselSubPages
